import * as FileSaver from 'file-saver';

export class HttpUtils {
  public static download(blob: Blob, headers: any) {
    let fileName = headers.get('content-disposition')?.split('filename=')[1]?.split(';')[0];
    if (fileName === null || fileName === undefined) {
      fileName = 'file'
    }
    const file = new File([blob], fileName.replace(/"/g, ''));
    FileSaver.saveAs(file);
  }
}
